<template>
  <div class="progress-spinner">
    <ProgressSpinner />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
@Options({})
export default class Loading extends Vue {}
</script>

<style lang="scss">
.loading {
  height: 100%;
  .progress-spinner {
    height: 100%;
    background: #f8f3f0;
    text-align: center;
  }
}
</style>
